import React from 'react'

import "./FormCompletion.scss"

const FormCompletion = () => {
  return (
    <div className="modern-assessment completion-celebration">
      <div className="completion-icon">
        ✅
      </div>
      <h2 className="assessment-title completion-title">
        Bedankt voor uw input!
      </h2>
      <p className="assessment-subtitle">
        Uw gegevens zijn succesvol opgeslagen. U kunt dit venster nu sluiten.
      </p>
    </div>
  )
}

export default FormCompletion